import Button from '@/cmsComponents/ButtonV2'
import Image from '@/components/Image'
import Features from '@/components/MachineCardV2/components/Features'
import { MachineResourceFeature } from '@/types/machines'
import { AllPlansForSmartphone } from '@/types/plans'

const tapTonFeatures = [
  {
    highlight: true,
    icon: 'logos-new',
    text: 'Seu celular vira maquininha'
  },
  {
    icon: 'phone-check',
    text: 'Precisa de celular com NFC'
  },
  {
    icon: 'signal-contactless',
    text: 'Receba por aproximação (NFC)'
  },
  {
    icon: 'message-r-chat',
    text: 'Comprovante por SMS'
  },
  {
    icon: 'dollar-phone',
    text: 'Venda pelo App com Link, Pix e Boleto'
  }
] as MachineResourceFeature[]

export const NewTapTonCard = () => {
  return (
    <div className="flex flex-col gap-24 items-stretch h-full bg-display-0 rounded-2xl shadow-new">
      <div className="flex relative justify-end items-end mr-16 ml-24 h-[148px] rounded rounded-b-none">
        <div className="absolute top-[-60px] sm:top-[-50px] left-0 max-w-[141px] sm:max-w-[172px]">
          <Image
            src="https://strapi-cms-media-customer-platforms-prd-264a.s3.us-east-1.amazonaws.com/ton-cms/prd/tapton_product_8297cffc68.webp"
            alt="Imagem do produto TapTon"
            width={165}
            height={195}
            className="object-cover max-w-full h-auto"
          />
        </div>

        <div className="flex justify-end mr-16">
          <Image
            src="site-ton/badge-venda-pelo-celular-new.png"
            alt="Icone representando a feature Venda Pelo Celular"
            className="max-w-full h-auto rounded-full"
            width={96}
            height={96}
          />
        </div>
      </div>
      <div className="flex flex-col px-16 w-full">
        <div className="flex flex-col gap-16 w-full">
          <h3 className="text-28 md:text-34 font-bold leading-36 lg:leading-48">
            TapTon
          </h3>

          <div className="flex justify-between w-full h-64">
            <p className="flex flex-col justify-end text-16 font-bold leading-26 text-newTon-700">
              <span>Taxas</span>
              <span>exclusivas</span>
            </p>

            <p className="flex flex-col justify-end font-heading text-40 font-bold leading-48 text-newTon-700">
              Grátis
            </p>
          </div>
        </div>
        <div className="flex mt-16 w-full">
          <Button
            handleAppDownload="default"
            size="large"
            linkTarget="_self"
            linkHref="https://appton.onelink.me/EhqG/2478x9gs"
            label="Venda pelo celular"
            className="md:w-full btn btn-primary btn-large"
            uiStyleVariant="button"
          />
        </div>
        <div className="flex flex-col gap-16 mt-24">
          <Features
            machine={AllPlansForSmartphone.Tapton}
            features={tapTonFeatures}
          />
        </div>
      </div>
    </div>
  )
}
